import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { AdminLayout } from './components/AdminLayout';
import { API_BASE_URL } from '../../config/apiConfig';

const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

const PageTitle = styled.h1`
  margin: 0;
  color: #2c3e50;
  font-size: 22px;
`;

const AddButton = styled.button`
  padding: 8px 12px;
  background-color: #ffffff;
  color: #2c3e50;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s;
  
  &:hover {
    background-color: #f7f7f7;
    border-color: #d5d5d5;
  }
`;

const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: white;
  padding: 30px;
  border-radius: 8px;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const ModalTitle = styled.h2`
  margin: 0;
  color: #2c3e50;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #7f8c8d;
  
  &:hover {
    color: #2c3e50;
  }
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  margin-bottom: 5px;
  font-weight: 500;
  color: #2c3e50;
`;

const Input = styled.input`
padding-top: 12px;
padding-bottom: 12px;/* 
padding-left: 12px;
padding-right: 12px; */
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  width: 100%;
  &:focus {
    outline: none;
    border-color: #3498db;
  }
`;

const TextArea = styled.textarea`
padding-top: 12px;
padding-bottom: 12px;/* 
padding-left: 12px;
padding-right: 12px; */
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  min-height: 100px;
  resize: vertical;
  width: 100%;
  &:focus {
    outline: none;
    border-color: #3498db;
  }
`;

const Select = styled.select`
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  
  &:focus {
    outline: none;
    border-color: #3498db;
  }
`;

const FormRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 20px;
`;

const SubmitButton = styled.button`
  padding: 12px 24px;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  
  &:hover {
    background-color: #3498db;
  }
  
  &:disabled {
    background-color: #95a5a6;
    cursor: not-allowed;
  }
`;

const CancelButton = styled.button`
  padding: 12px 24px;
  background-color: #95a5a6;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  
  &:hover {
    background-color: #7f8c8d;
  }
`;

const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 16px;
`;

const ProductCard = styled.div`
  background-color: white;
  border-radius: 10px;
  padding: 16px;
  box-shadow: none;
  transition: border-color 0.2s ease;
  display: flex;
  flex-direction: column;
  /* height: 100%; */
  position: relative;
  border: 1px solid #eeeeee;
  
  &:hover {
    border-color: #e0e0e0;
  }
  
  ${props => props.disabled && `
    opacity: 0.6;
    background-color: #f8f9fa;
    border: 1px solid #e9ecef;
  `}
`;

const ProductStatus = styled.div`
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 2;
`;

const StatusToggle = styled.button`
  background-color: ${props => props.enabled ? '#2ecc71' : '#e74c3c'};
  color: #ffffff;
  border: none;
  border-radius: 14px;
  padding: 4px 8px;
  font-size: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
  text-transform: none;
  letter-spacing: 0;
  
  &:hover {
    background-color: ${props => props.enabled ? '#27ae60' : '#c0392b'};
  }
  
  &:disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }
`;

const ProductImage = styled.div`
  width: 100%;
  height: 160px;
  background-color: #f5f5f5;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  color: #7f8c8d;
  font-size: 14px;
  overflow: hidden;
`;

const ProductName = styled.h3`
  margin: 0 0 8px 0;
  color: #2c3e50;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const ProductPrice = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #2c3e50;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  gap: 4px;
`;

const PriceGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
  padding: 12px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
`;

const PriceRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const PriceLabel = styled.span`
  font-size: 11px;
  color: #6c757d;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const SavingsIndicator = styled.div`
  background-color: #e8f5e8;
  color: #27ae60;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  text-align: center;
  margin-top: 8px;
`;

const ProductDescription = styled.p`
  color: #7f8c8d;
  font-size: 10px;
  margin: 0 0 12px 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const ProductMeta = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 11px;
  color: #95a5a6;
  margin-top: auto;
  padding-top: 12px;
  border-top: 1px solid #f2f2f2;
  gap: 4px;
`;

const MetaItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
`;

const MetaLabel = styled.span`
  font-size: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #95a5a6;
`;

const MetaValue = styled.span`
  font-size: 8px;
  font-weight: 500;
  color: #2c3e50;
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 60px 20px;
  color: #7f8c8d;
`;

const EmptyIcon = styled.div`
  font-size: 48px;
  margin-bottom: 20px;
`;

const EmptyText = styled.p`
  font-size: 18px;
  margin-bottom: 20px;
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 20px;
  flex-direction: column;
  gap: 20px;
`;

const LoadingSpinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const LoadingText = styled.p`
  color: #7f8c8d;
  font-size: 16px;
`;

const ErrorContainer = styled.div`
  background-color: #fee;
  border: 1px solid #fcc;
  border-radius: 6px;
  padding: 15px;
  margin: 20px 0;
  color: #c33;
`;

const ErrorButton = styled.button`
  background-color: #e74c3c;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  margin-top: 10px;
  
  &:hover {
    background-color: #c0392b;
  }
`;

const DescriptionSection = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  background-color: #fafafa;
  position: relative;
`;

const DescriptionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e8e8e8;
`;

const DescriptionLabel = styled.span`
  font-weight: 600;
  color: #2c3e50;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const DescriptionFieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const DescriptionFieldWrapper = styled.div`
  position: relative;
`;

const DescriptionFieldLabel = styled.label`
  font-size: 12px;
  font-weight: 500;
  color: #666;
  margin-bottom: 4px;
  display: block;
  text-transform: uppercase;
  letter-spacing: 0.3px;
`;

const RemoveButton = styled.button`
  background-color: #e74c3c;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #c0392b;
    transform: translateY(-1px);
  }
`;

const AddButton2 = styled.button`
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 16px;
  width: 100%;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #2980b9;
    transform: translateY(-1px);
  }
`;

const ImageSection = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 15px;
  margin-bottom: 15px;
  background-color: #fafafa;
`;

const ImageRow = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 10px;
`;

const BrandInputRow = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  margin-top: 10px;
`;

const SmallButton = styled.button`
  padding: 8px 12px;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  
  &:hover {
    background-color: #3498db;
  }
`;

const ProductImages = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 10px;
  margin-bottom: 15px;
`;

const ProductImageContainer = styled.div`
  width: 100%;
  height: 120px;
  background-color: #ecf0f1;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #7f8c8d;
  font-size: 12px;
  overflow: hidden;
`;

const ProductDescriptions = styled.div`
  margin-bottom: 18px;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  background-color: #fafafa;
  padding: 12px;
`;

const DescriptionItem = styled.div`
  background-color: white;
  padding: 12px;
  border-radius: 6px;
  margin-bottom: 8px;
  border: 1px solid #e8e8e8;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const DescriptionTitle = styled.div`
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 6px;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 4px;
`;

const DescriptionContent = styled.div`
  color: #555;
  font-size: 13px;
  line-height: 1.5;
  margin-top: 6px;
`;



// API Functions
const fetchProducts = async () => {
  try {
    const token = sessionStorage.getItem('admin-token');
    const response = await fetch(`${API_BASE_URL}/product/list?enabled_only=false`, {
      headers: {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': token })
      }
    });
    
    const result = await response.json();
    if (result.is_success) {
      return result.data.products;
    } else {
      throw new Error(result.error || 'Failed to fetch products');
    }
  } catch (error) {
    console.error('Error fetching products:', error);
    throw error;
  }
};

const createProduct = async (productData) => {
  try {
    const token = sessionStorage.getItem('admin-token');
    console.log('token:', token)
    if (!token) {
      throw new Error('Authentication required');
    }

    const response = await fetch(`${API_BASE_URL}/product/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token
      },
      body: JSON.stringify(productData)
    });
    
    const result = await response.json();
    if (result.is_success) {
      return result.data;
    } else {
      throw new Error(result.error || 'Failed to create product');
    }
  } catch (error) {
    console.error('Error creating product:', error);
    throw error;
  }
};

// Add new API function to toggle product status
const toggleProductStatus = async (productId) => {
  try {
    const token = sessionStorage.getItem('admin-token');
    if (!token) {
      throw new Error('Authentication required');
    }

    const response = await fetch(`${API_BASE_URL}/product/toggle-status/${productId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token
      }
    });
    
    const result = await response.json();
    if (result.is_success) {
      return result.data;
    } else {
      throw new Error(result.error || 'Failed to toggle product status');
    }
  } catch (error) {
    console.error('Error toggling product status:', error);
    throw error;
  }
};

// Add update product API
const updateProduct = async (productId, productData) => {
  try {
    const token = sessionStorage.getItem('admin-token');
    if (!token) {
      throw new Error('Authentication required');
    }

    const response = await fetch(`${API_BASE_URL}/product/update/${productId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token
      },
      body: JSON.stringify(productData)
    });

    const result = await response.json();
    if (result.is_success) {
      return result.data;
    } else {
      throw new Error(result.error || 'Failed to update product');
    }
  } catch (error) {
    console.error('Error updating product:', error);
    throw error;
  }
};

export function ProductCatalog() {
  const [showModal, setShowModal] = useState(false);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [showNewBrandInput, setShowNewBrandInput] = useState(false);
  const [newBrandName, setNewBrandName] = useState('');
  const [editingProduct, setEditingProduct] = useState(null);
  const [brands, setBrands] = useState([
    'Apple', 'Samsung', 'Sony', 'LG', 'Dell', 'HP', 'Lenovo', 'Asus', 'Nike', 'Adidas', 'Puma', 'Canon', 'Nikon'
  ]);
  const [formData, setFormData] = useState({
    name: '',
    descriptions: [{ title: '', content: '' }],
    price: '',
    gstRate: '18',
    priceInputType: 'inclusive',
    hsn: '',
    amazonPrice: '',
    category: '',
    brand: '',
    sku: '',
    stock: '',
    images: [''],
    variantGroup: '',
    isVariantPrimary: false,
    saleStartAt: '',
    saleEndAt: ''
  });

  // Fetch products on component mount
  useEffect(() => {
    loadProducts();
  }, []);

  const loadProducts = async () => {
    try {
      setLoading(true);
      setError(null);
      const fetchedProducts = await fetchProducts();
      setProducts(fetchedProducts);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const openCreateModal = () => {
    setEditingProduct(null);
    setFormData({
      name: '',
      descriptions: [{ title: '', content: '' }],
      price: '',
      gstRate: '18',
      priceInputType: 'inclusive',
      hsn: '',
      amazonPrice: '',
      category: '',
      brand: '',
      sku: '',
      stock: '',
      images: [''],
      variantGroup: '',
      isVariantPrimary: false,
      saleStartAt: '',
      saleEndAt: ''
    });
    setShowModal(true);
  };

  const formatForDateTimeLocal = (value) => {
    if (!value) return '';
    const d = new Date(value);
    const pad = (n) => String(n).padStart(2, '0');
    const yyyy = d.getFullYear();
    const mm = pad(d.getMonth() + 1);
    const dd = pad(d.getDate());
    const hh = pad(d.getHours());
    const min = pad(d.getMinutes());
    return `${yyyy}-${mm}-${dd}T${hh}:${min}`;
  };

  const openEditModal = (product) => {
    setEditingProduct(product);
    setShowNewBrandInput(false);
    setNewBrandName('');
    setFormData({
      name: product.name || '',
      descriptions: product.descriptions && product.descriptions.length ? product.descriptions : [{ title: '', content: '' }],
      price: product.price != null ? product.price : '',
      gstRate: product.gstRate != null ? String(product.gstRate) : '18',
      priceInputType: 'inclusive',
      hsn: product.hsn != null ? String(product.hsn) : '',
      amazonPrice: product.amazonPrice != null ? product.amazonPrice : '',
      category: product.category || '',
      brand: product.brand || '',
      sku: product.sku || '',
      stock: product.stock != null ? product.stock : '',
      images: product.images && product.images.length ? product.images : [''],
      variantGroup: product.variantGroup || '',
      isVariantPrimary: !!product.isVariantPrimary,
      saleStartAt: formatForDateTimeLocal(product.saleStartAt),
      saleEndAt: formatForDateTimeLocal(product.saleEndAt)
    });
    setShowModal(true);
  };

  const categories = [
    'Electronics',
    'Clothing',
    'Home & Garden',
    'Sports & Outdoors',
    'Beauty & Personal Care',
    'Books',
    'Toys & Games',
    'Automotive'
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => {
      if (name === 'priceInputType') {
        const rate = Math.max(0, Math.min(100, Number(prev.gstRate) || 0)) / 100;
        const currentPrice = Number(prev.price);
        let nextPrice = prev.price;
        if (Number.isFinite(currentPrice) && currentPrice >= 0 && value !== prev.priceInputType) {
          if (prev.priceInputType === 'inclusive' && value === 'exclusive') {
            nextPrice = rate > 0 ? (currentPrice / (1 + rate)).toFixed(2) : currentPrice.toFixed(2);
          } else if (prev.priceInputType === 'exclusive' && value === 'inclusive') {
            nextPrice = (currentPrice * (1 + rate)).toFixed(2);
          }
        }
        return {
          ...prev,
          priceInputType: value,
          price: nextPrice
        };
      }
      return {
        ...prev,
        [name]: value
      };
    });
  };

  const handleDescriptionChange = (index, field, value) => {
    const newDescriptions = [...formData.descriptions];
    newDescriptions[index][field] = value;
    setFormData(prev => ({
      ...prev,
      descriptions: newDescriptions
    }));
  };

  const addDescription = () => {
    setFormData(prev => ({
      ...prev,
      descriptions: [...prev.descriptions, { title: '', content: '' }]
    }));
  };

  const removeDescription = (index) => {
    if (formData.descriptions.length > 1) {
      const newDescriptions = formData.descriptions.filter((_, i) => i !== index);
      setFormData(prev => ({
        ...prev,
        descriptions: newDescriptions
      }));
    }
  };

  const handleImageChange = (index, value) => {
    const newImages = [...formData.images];
    newImages[index] = value;
    setFormData(prev => ({
      ...prev,
      images: newImages
    }));
  };

  const addImage = () => {
    setFormData(prev => ({
      ...prev,
      images: [...prev.images, '']
    }));
  };

  const removeImage = (index) => {
    if (formData.images.length > 1) {
      const newImages = formData.images.filter((_, i) => i !== index);
      setFormData(prev => ({
        ...prev,
        images: newImages
      }));
    }
  };

  const handleBrandChange = (e) => {
    const value = e.target.value;
    if (value === 'add_new') {
      setShowNewBrandInput(true);
    } else {
      setFormData(prev => ({ ...prev, brand: value }));
      setShowNewBrandInput(false);
    }
  };

  const addNewBrand = () => {
    if (newBrandName.trim() && !brands.includes(newBrandName.trim())) {
      const newBrand = newBrandName.trim();
      setBrands(prev => [...prev, newBrand].sort());
      setFormData(prev => ({ ...prev, brand: newBrand }));
      setNewBrandName('');
      setShowNewBrandInput(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      setSubmitting(true);
      setError(null);
      
      // Prepare product data for API
      const productData = {
        ...formData,
        price: formData.price !== '' ? parseFloat(formData.price) : null,
        gstRate: formData.gstRate !== '' ? parseFloat(formData.gstRate) : 18,
        priceInputType: formData.priceInputType || 'inclusive',
        hsn: (formData.hsn || '').trim() || null,
        amazonPrice: formData.amazonPrice !== '' ? parseFloat(formData.amazonPrice) : null,
        stock: formData.stock !== '' ? parseInt(formData.stock) : null,
        images: formData.images.filter(img => img.trim() !== ''),
        variantGroup: formData.variantGroup && formData.variantGroup.trim() !== '' ? formData.variantGroup.trim() : null,
        isVariantPrimary: !!formData.isVariantPrimary,
        saleStartAt: formData.saleStartAt || null,
        saleEndAt: formData.saleEndAt || null
      };
      
      if (editingProduct) {
        // Update product via API
        const updated = await updateProduct(editingProduct.id, productData);
        // Update list
        setProducts(prev => prev.map(p => (p.id === updated.id ? updated : p)));
      } else {
        // Create product via API
        const newProduct = await createProduct(productData);
        // Add new product to local state
        setProducts(prev => [newProduct, ...prev]);
      }
      
      // Reset form and close modal
      setFormData({
        name: '',
        descriptions: [{ title: '', content: '' }],
        price: '',
        gstRate: '18',
        priceInputType: 'inclusive',
        hsn: '',
        amazonPrice: '',
        category: '',
        brand: '',
        sku: '',
        stock: '',
        images: [''],
        variantGroup: '',
        isVariantPrimary: false,
        saleStartAt: '',
        saleEndAt: ''
      });
      setShowModal(false);
      setShowNewBrandInput(false);
      setNewBrandName('');
      setEditingProduct(null);
      
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    setFormData({
      name: '',
      descriptions: [{ title: '', content: '' }],
      price: '',
      gstRate: '18',
      priceInputType: 'inclusive',
      hsn: '',
      amazonPrice: '',
      category: '',
      brand: '',
      sku: '',
      stock: '',
      images: [''],
      variantGroup: '',
      isVariantPrimary: false,
      saleStartAt: '',
      saleEndAt: ''
    });
    setShowModal(false);
    setShowNewBrandInput(false);
    setNewBrandName('');
    setEditingProduct(null);
    setError(null);
    setSubmitting(false);
  };

  // Add function to handle status toggle
  const handleStatusToggle = async (productId, currentStatus) => {
    try {
      const updatedProduct = await toggleProductStatus(productId);
      
      // Update local state with the returned product data
      setProducts(prev => prev.map(product => 
        product.id === productId 
          ? updatedProduct
          : product
      ));
    } catch (err) {
      setError(`Failed to ${currentStatus ? 'disable' : 'enable'} product: ${err.message}`);
    }
  };

  // Add function to format price in rupees
  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(price);
  };

  // Add function to calculate savings
  const calculateSavings = (ourPrice, amazonPrice) => {
    if (!amazonPrice || amazonPrice <= ourPrice) return null;
    const savings = amazonPrice - ourPrice;
    const percentage = Math.round((savings / amazonPrice) * 100);
    return { amount: savings, percentage };
  };

  const gstRateForPreview = Math.max(0, Math.min(100, Number(formData.gstRate) || 0));
  const enteredPriceForPreview = Number(formData.price);
  const grossPricePreview = Number.isFinite(enteredPriceForPreview) && enteredPriceForPreview >= 0
    ? (formData.priceInputType === 'exclusive'
      ? enteredPriceForPreview * (1 + gstRateForPreview / 100)
      : enteredPriceForPreview)
    : null;

  return (
    <AdminLayout>
      <PageHeader>
        <PageTitle>Product Catalog</PageTitle>
        <AddButton onClick={openCreateModal}>
          + Add Product
        </AddButton>
      </PageHeader>

      {error && (
        <ErrorContainer>
          <div>Error: {error}</div>
          <ErrorButton onClick={loadProducts}>
            Try Again
          </ErrorButton>
        </ErrorContainer>
      )}

      {loading ? (
        <LoadingContainer>
          <LoadingSpinner />
          <LoadingText>Loading products...</LoadingText>
        </LoadingContainer>
      ) : products.length === 0 ? (
        <EmptyState>
          <EmptyIcon />
          <EmptyText>No products yet</EmptyText>
          <p>Start by adding your first product to the catalog</p>
        </EmptyState>
      ) : (
        <ProductGrid>
          {products.map(product => {
            const savings = product.amazonPrice ? calculateSavings(product.price, product.amazonPrice) : null;
                         return (
              <ProductCard key={product.id} disabled={!product.isEnabled}>
                <ProductStatus>
                  <StatusToggle 
                    enabled={product.isEnabled}
                    onClick={() => handleStatusToggle(product.id, product.isEnabled)}
                    title={product.isEnabled ? 'Click to disable product' : 'Click to enable product'}
                  >
                    {product.isEnabled ? 'Active' : 'Disabled'}
                  </StatusToggle>
                </ProductStatus>
                <ProductImage>
                  {product.images && product.images[0] ? (
                    <img src={product.images[0]} alt={`${product.name}`} style={{width: '100%', height: '100%', objectFit: 'cover'}} />
                  ) : (
                    'No Image'
                  )}
                </ProductImage>
                
                <ProductName>{product.name}</ProductName>

                <PriceRow>
                  <div>
                    <ProductPrice>{formatPrice(product.price)}</ProductPrice>
                  </div>
                  {product.amazonPrice && (
                    <div style={{ textAlign: 'right' }}>
                      <span style={{ color: '#999', textDecoration: 'line-through', fontSize: '12px' }}>
                        {formatPrice(product.amazonPrice)}
                      </span>
                    </div>
                  )}
                </PriceRow>
                
                {product.descriptions && product.descriptions[0] && product.descriptions[0].content && (
                  <ProductDescription>
                    {product.descriptions[0].content.substring(0, 90)}
                    {product.descriptions[0].content.length > 90 ? '...' : ''}
                  </ProductDescription>
                )}
                
                <ProductMeta>
                  <MetaItem>
                    <MetaValue>{product.brand}</MetaValue>
                    <MetaLabel>Brand</MetaLabel>
                  </MetaItem>
                  <MetaItem>
                    <MetaValue>{product.category}</MetaValue>
                    <MetaLabel>Category</MetaLabel>
                  </MetaItem>
                  {product.variantGroup && (
                  <MetaItem>
                    <MetaValue>{product.variantGroup}</MetaValue>
                      <MetaLabel>Variant</MetaLabel>
                    </MetaItem>
                  )}
                  <MetaItem>
                    <MetaValue>{product.stock}</MetaValue>
                    <MetaLabel>Stock</MetaLabel>
                  </MetaItem>
                </ProductMeta>

                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 12 }}>
                  <AddButton onClick={() => openEditModal(product)}>Edit</AddButton>
                </div>
              </ProductCard>
            );
          })}
        </ProductGrid>
      )}

      {showModal && (
        <Modal>
          <ModalContent>
            <ModalHeader>
              <ModalTitle>{editingProduct ? 'Edit Product' : 'Add New Product'}</ModalTitle>
              <CloseButton onClick={handleCancel}>&times;</CloseButton>
            </ModalHeader>
            
            <Form onSubmit={handleSubmit}>
              {error && (
                <ErrorContainer>
                  {error}
                </ErrorContainer>
              )}
              
              <FormGroup>
                <Label htmlFor="name">Product Name *</Label>
                <Input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  disabled={submitting}
                />
              </FormGroup>
              
                             <FormGroup>
                 <Label>Product Descriptions</Label>
                 {formData.descriptions.map((desc, index) => (
                   <DescriptionSection key={index}>
                     <DescriptionHeader>
                       <DescriptionLabel>Section {index + 1}</DescriptionLabel>
                       {formData.descriptions.length > 1 && (
                         <RemoveButton onClick={() => removeDescription(index)}>
                           Remove Section
                         </RemoveButton>
                       )}
                     </DescriptionHeader>
                     
                     <DescriptionFieldGroup>
                       <DescriptionFieldWrapper>
                         <DescriptionFieldLabel>Section Title</DescriptionFieldLabel>
                         <Input
                           type="text"
                           placeholder="e.g., Key Features, Specifications, Overview"
                           value={desc.title}
                           onChange={(e) => handleDescriptionChange(index, 'title', e.target.value)}
                         />
                       </DescriptionFieldWrapper>
                       
                       <DescriptionFieldWrapper>
                         <DescriptionFieldLabel>Section Content</DescriptionFieldLabel>
                         <TextArea
                           placeholder="Enter detailed description content for this section..."
                           value={desc.content}
                           onChange={(e) => handleDescriptionChange(index, 'content', e.target.value)}
                           rows="4"
                         />
                       </DescriptionFieldWrapper>
                     </DescriptionFieldGroup>
                   </DescriptionSection>
                 ))}
                 <AddButton2 type="button" onClick={addDescription}>
                   + Add Another Description Section
                 </AddButton2>
               </FormGroup>
              
                             <FormRow>
                 <FormGroup>
                   <Label htmlFor="price">Our Price *</Label>
                   <Input
                     type="number"
                     id="price"
                     name="price"
                     step="0.01"
                     min="0"
                     value={formData.price}
                     onChange={handleInputChange}
                     required
                   />
                 </FormGroup>
                 
                 <FormGroup>
                   <Label htmlFor="amazonPrice">Amazon Price</Label>
                   <Input
                     type="number"
                     id="amazonPrice"
                     name="amazonPrice"
                     step="0.01"
                     min="0"
                     value={formData.amazonPrice}
                     onChange={handleInputChange}
                     placeholder="Optional"
                   />
                 </FormGroup>
               </FormRow>

               <FormRow>
                 <FormGroup>
                   <Label htmlFor="gstRate">GST Rate (%)</Label>
                   <Input
                     type="number"
                     id="gstRate"
                     name="gstRate"
                     step="0.01"
                     min="0"
                     max="100"
                     value={formData.gstRate}
                     onChange={handleInputChange}
                     required
                   />
                 </FormGroup>
                 <FormGroup>
                   <Label htmlFor="priceInputType">Price entered as</Label>
                   <Select
                     id="priceInputType"
                     name="priceInputType"
                     value={formData.priceInputType}
                     onChange={handleInputChange}
                   >
                     <option value="inclusive">Inclusive of GST</option>
                     <option value="exclusive">Exclusive of GST</option>
                   </Select>
                 </FormGroup>
               </FormRow>
               <FormRow>
                 <FormGroup>
                   <Label htmlFor="hsn">HSN/SAC</Label>
                   <Input
                     type="text"
                     id="hsn"
                     name="hsn"
                     value={formData.hsn}
                     onChange={handleInputChange}
                     placeholder="Optional"
                     disabled={submitting}
                   />
                 </FormGroup>
                 <FormGroup />
               </FormRow>
               {grossPricePreview != null && (
                 <div style={{ fontSize: 12, color: '#6c757d', marginTop: -8 }}>
                   Final customer price (incl GST): <strong>{formatPrice(grossPricePreview)}</strong>
                 </div>
               )}
               
               <FormRow>
                 <FormGroup>
                   <Label htmlFor="category">Category *</Label>
                   <Select
                     id="category"
                     name="category"
                     value={formData.category}
                     onChange={handleInputChange}
                     required
                   >
                     <option value="">Select category</option>
                     {categories.map(category => (
                       <option key={category} value={category}>{category}</option>
                     ))}
                   </Select>
                 </FormGroup>
                 
                 <FormGroup>
                   <Label htmlFor="sku">SKU</Label>
                   <Input
                     type="text"
                     id="sku"
                     name="sku"
                     value={formData.sku}
                     onChange={handleInputChange}
                     placeholder="e.g., PROD-001"
                   />
                 </FormGroup>
               </FormRow>
              
                             <FormGroup>
                 <Label htmlFor="brand">Brand</Label>
                 <Select
                   id="brand"
                   name="brand"
                   value={formData.brand}
                   onChange={handleBrandChange}
                 >
                   <option value="">Select brand</option>
                   {brands.map(brand => (
                     <option key={brand} value={brand}>{brand}</option>
                   ))}
                   <option value="add_new">+ Add New Brand</option>
                 </Select>
                 
                 {showNewBrandInput && (
                   <BrandInputRow>
                     <Input
                       type="text"
                       placeholder="Enter new brand name"
                       value={newBrandName}
                       onChange={(e) => setNewBrandName(e.target.value)}
                       onKeyPress={(e) => e.key === 'Enter' && addNewBrand()}
                     />
                     <SmallButton type="button" onClick={addNewBrand}>
                       Add
                     </SmallButton>
                     <SmallButton 
                       type="button" 
                       onClick={() => {setShowNewBrandInput(false); setNewBrandName('');}}
                       style={{ backgroundColor: '#95a5a6' }}
                     >
                       Cancel
                     </SmallButton>
                   </BrandInputRow>
                 )}
               </FormGroup>
              
                             <FormGroup>
                 <Label htmlFor="stock">Stock Quantity *</Label>
                 <Input
                   type="number"
                   id="stock"
                   name="stock"
                   min="0"
                   value={formData.stock}
                   onChange={handleInputChange}
                   required
                   style={{ maxWidth: '200px' }}
                 />
               </FormGroup>
               
               <FormRow>
                <FormGroup>
                  <Label htmlFor="variantGroup">Variant Group</Label>
                  <Input
                    type="text"
                    id="variantGroup"
                    name="variantGroup"
                    placeholder="e.g., iphone-16-pro"
                    value={formData.variantGroup}
                    onChange={handleInputChange}
                  />
                </FormGroup>
                <FormGroup>
                  <Label htmlFor="isVariantPrimary">Primary Variant</Label>
                  <input
                    type="checkbox"
                    id="isVariantPrimary"
                    name="isVariantPrimary"
                    checked={!!formData.isVariantPrimary}
                    onChange={(e) => setFormData(prev => ({ ...prev, isVariantPrimary: e.target.checked }))}
                    style={{ width: 18, height: 18 }}
                  />
                </FormGroup>
              </FormRow>

              <FormRow>
                <FormGroup>
                  <Label htmlFor="saleStartAt">Sale Start (date & time)</Label>
                  <Input
                    type="datetime-local"
                    id="saleStartAt"
                    name="saleStartAt"
                    value={formData.saleStartAt}
                    onChange={handleInputChange}
                  />
                </FormGroup>
                <FormGroup>
                  <Label htmlFor="saleEndAt">Sale End (date & time)</Label>
                  <Input
                    type="datetime-local"
                    id="saleEndAt"
                    name="saleEndAt"
                    value={formData.saleEndAt}
                    onChange={handleInputChange}
                  />
                </FormGroup>
              </FormRow>

              <FormGroup>
                <Label>Product Images</Label>
                <ImageSection>
                  {formData.images.map((image, index) => (
                    <ImageRow key={index}>
                      <Input
                        type="url"
                        placeholder={`Image URL ${index + 1}`}
                        value={image}
                        onChange={(e) => handleImageChange(index, e.target.value)}
                        style={{ flex: 1 }}
                      />
                      {formData.images.length > 1 && (
                        <RemoveButton onClick={() => removeImage(index)}>
                          Remove
                        </RemoveButton>
                      )}
                    </ImageRow>
                  ))}
                  <AddButton2 type="button" onClick={addImage}>
                    + Add Another Image
                  </AddButton2>
                </ImageSection>
              </FormGroup>
              
              <ButtonGroup>
                <CancelButton type="button" onClick={handleCancel} disabled={submitting}>
                  Cancel
                </CancelButton>
                <SubmitButton type="submit" disabled={submitting}>
                  {submitting ? (editingProduct ? 'Saving Changes...' : 'Adding Product...') : (editingProduct ? 'Save Changes' : 'Add Product')}
                </SubmitButton>
              </ButtonGroup>
            </Form>
          </ModalContent>
        </Modal>
      )}
    </AdminLayout>
  );
} 